<template>
  <div class="mr-5 mb-2 cursor-pointer">
    <div
      class="select-none text-base font-semibold transition-all hover:text-primary-light"
      :class="isActive ? 'text-primary' : 'text-grey'"
      @click="$emit('click', filter.id)"
    >
      {{ filter.text }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "FilterTab",
  components: {},
  emits: ["click"],
  props: {
    filter: { required: true },
    isActive: { type: Boolean, required: true },
  },
});
</script>
